module.exports = __webpack_public_path__ + "fonts/99a012d.woff";